import { useCallback, useMemo, useState } from "react"

import { Form, Formik } from "formik"

import { useMyUserContext } from "@l2r-front/l2r-auth"
import { useTranslation } from "@l2r-front/l2r-i18n"
import { PropTypes } from "@l2r-front/l2r-proptypes"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { usePasswordFormModal } from "../../hooks/usePasswordFormModal"

import { emailValidationSchema } from "./ChangeEmailForm.schema"
import * as Styled from "./ChangeEmailForm.styled"

export const ChangeEmailForm = (props) => {

    const {
        autoFocus,
        className,
        onSubmit,
    } = props

    const isMobile = useIsMobileDevice()
    const { t } = useTranslation(I18N_NAMESPACE)
    const { user } = useMyUserContext()
    const [errors, setErrors] = useState(null)

    const onError = useCallback((errors) => {
        const errorsArray = Object.keys(errors).reduce((accArray, key) => {
            return accArray.concat(errors[key])
        }, [])
        setErrors(errorsArray.join("\n"))
    }, [setErrors])

    const { modal, setFormValues } = usePasswordFormModal(
        onSubmit,
        onError,
        t(I18N_NAMESPACE, "forms.changeEmailForm.modal.title"),
        t(I18N_NAMESPACE, "forms.changeEmailForm.modal.desc"),
    )

    const formikProps = useMemo(() => {
        return {
            validationSchema: emailValidationSchema(t),
            initialValues: {
                email: user?.email || "",
            },
            onSubmit: (values, { setStatus, setSubmitting }) => {
                setStatus(null)
                setErrors(null)
                setFormValues(values)
                setSubmitting(false)
            },
        }
    }, [setFormValues, t, user])

    return <Styled.Wrapper isMobile={isMobile}>
        <Styled.Title variant="H4">{t(I18N_NAMESPACE, "forms.changeEmailForm.title")}</Styled.Title>
        <Formik {...formikProps}>
            {(formikState) => {
                return <Form className={className}>
                    {(formikState.status || errors) && (
                        <Styled.FormHelperText error>{formikState.status || errors}</Styled.FormHelperText>
                    )}
                    <Styled.FormikTextField
                        autoFocus={!!autoFocus}
                        fullWidth
                        variant="outlined"
                        label={t(I18N_NAMESPACE, "forms.changeEmailForm.fields.email.label")}
                        labelVariant="H3"
                        margin="normal"
                        name="email"
                        type="email"
                    />
                    <Styled.SubmitWrapper isMobile={isMobile}>
                        <Styled.FormikButtonSubmit isMobile={isMobile}>
                            {t(I18N_NAMESPACE, "forms.changeEmailForm.actions.submit")}
                        </Styled.FormikButtonSubmit>
                    </Styled.SubmitWrapper>
                </Form>
            }}
        </Formik>
        {modal}
    </Styled.Wrapper>
}

ChangeEmailForm.propTypes = {
    autoFocus: PropTypes.bool,
    className: PropTypes.string,
    onSubmit: PropTypes.func.isRequired,
}
